import { RejectionDSAType } from "@nkr/enums/rejection-dsa-type"

export interface ITransplantRejectionDSA {
    id: number,
    rejectionId: number,
    dsaType: RejectionDSAType,
    allele: string,
    alleleName: string,
    mfi: number
}